<script>
  import { onMount } from 'svelte'
  import { getContext } from 'svelte'
  import { contextKey } from './mapbox.js'

  const { getMap, getMapbox } = getContext(contextKey)
  const map = getMap()
  const mapbox = getMapbox()

  function randomColour () {
    return Math.round(Math.random() * 255)
  }

  function move (lng, lat) {
    marker.setLngLat({ lng, lat })
  }

  export let lat
  export let lng
  export let label = 'Marker'
  export let popupClassName = 'beyonk-mapbox-popup'
  export let markerOffset = [ 0, 0 ]
  export let popupOffset = 10
  export let color = randomColour()
  export let visible = true
  export let width = 0
  export let height = 0 
  export let cinema
  export let show = false
  export let showncinema = '0'

  $: marker = new mapbox.Marker({ color, offset: markerOffset, height, width})
  let popupEl;
    
  $: if (visible) {
    popupEl = new mapbox.Popup({
        offset: popupOffset,
        className: popupClassName
      }).setHTML(label)

    marker.setPopup(popupEl)

    marker
      .setLngLat({ lng, lat })
      .addTo(map)

    popupEl.on('open',   function () {
      show = true
      showncinema = cinema
    });

    popupEl.on('close', () => show = false ); 

  } else if (visible === false) {
    marker.remove()
  }

  export function getMarker () {
    return marker
  }
</script>
